// extracted by mini-css-extract-plugin
export var card = "_l9-5";
export var cardSelected = "_l9-4";
export var image = "_l9-3";
export var modal = "_l9-0";
export var modalContent = "_l9-1";
export var table = "_l9-2";